export default __webpack_public_path__ + "static/Principle-flow-dark-ea74cc2a62b5058f0458a0b93f7a59c0.png";